import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Fonts are preloaded in the HTML document */

  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.sans};
    color: ${({ theme }) => theme.colors.ink};
    background-color: ${({ theme }) => theme.colors.paper};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.white};
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  em {
    font-family: ${({ theme }) => theme.fonts.serif};
    font-style: italic;
    font-weight: 400;
  }

  a {
    color: ${({ theme }) => theme.colors.accent};
    text-decoration: none;
    transition: color 0.2s ease;
  }

  a:hover {
    color: ${({ theme }) => theme.colors.ink};
  }

  a:focus-visible,
  button:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 3px;
    border-radius: 4px;
  }

  button {
    font: inherit;
    cursor: pointer;
  }

  img {
    display: block;
    max-width: 100%;
  }

  /* Keep anchor targets clear of the fixed navbar */
  [id] {
    scroll-margin-top: 88px;
  }

  #top {
    scroll-margin-top: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *, *::before, *::after {
      animation: none !important;
      transition: none !important;
    }
  }

  [data-reduce-motion] {
    &, & *, & *::before, & *::after {
      animation: none !important;
      transition: none !important;
    }
  }
`;

export default GlobalStyle;
